<template>
  <div class="finance">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div class="table-agile-info">
            <div class="common-new-title mode2">
              <span>批量确认</span>
            </div>
            <div class="search-btn" v-if="$hasPermission(171)">
              <jm-upload
                v-if="!isUploadSuccess"
                style="display: inline-block; position: relative; margin-left: 5px;"
                class="jm-input135"
                action="/newfib.php/finance/trade/uploadExcel"
                :file-list="uploadExcelFiles"
                :show-file-list="false"
                :on-progress="batchUplaodProcess"
                :on-success="batchUplaodSuccess"
                :on-error="batchUplaodError"
                :disabled="btnUploadLoading"
                accept=".xlsx, .xls, .csv">
                <el-button type="success" icon="el-icon-upload" :loading="btnUploadLoading">{{ btnUploadLoading ? '确认文件上传中 ...' : '上传到账确认文件' }}</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </jm-upload>
              <template v-else>
                <el-button v-show="runLock" type="primary" @click="batchConfrim()">{{ timerRunning ? '暂停执行' : timerIndex !== 0 ? '继续执行' : '批量执行' }}</el-button>
                <el-button type="info" @click="resetConfirm">重新上传</el-button>

                <el-alert style="margin-top: 20px" v-if="batchTitle" :title="batchTitle" type="success" :closable="false"></el-alert>
              </template>
            </div>
            <!--列表部分 start -->
            <el-table :data="tableData" style="width: 100%">
              <el-table-column
                fixed
                prop="id"
                label="系统ID"
                width="100">
              </el-table-column>
              <el-table-column
                prop="pub_account"
                label="姓名"
                width="120">
              </el-table-column>
              <el-table-column
                prop="total_amount"
                label="实付金额"
                width="120">
              </el-table-column>
              <el-table-column
                prop="confirm_date"
                label="确认到账日期"
                width="120">
              </el-table-column>
              <el-table-column
                prop="order_no"
                label="订单编号"
                width="200">
              </el-table-column>
              <el-table-column
                prop="pub_teacher"
                label="顾问老师"
                width="300">
              </el-table-column>
              <el-table-column
                prop="paid_time"
                label="付款时间"
                width="120">
              </el-table-column>
              <el-table-column
                prop="create_time"
                label="报账时间"
                width="120">
              </el-table-column>
              <el-table-column
                prop="project_name"
                label="平台名称"
                width="120">
              </el-table-column>
              <el-table-column
                prop="trade_type_str"
                label="审核类型"
                width="120">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="结果"
                width="180">
                <template slot-scope="scope">
                  <font color="red" v-if="scope.row.confirm_status === -1">
                    {{ scope.row.confirm_result }}
                  </font>
                  <font color="green" v-if="scope.row.confirm_status === 1">
                    操作成功
                  </font>
                  <font v-if="scope.row.confirm_status === 0 && batchTitle !== ''">
                    <i class="el-icon-loading"></i> 执行中 ...
                  </font>
                </template>
              </el-table-column>
            </el-table>
            <!--列表部分 end-->
          </div>

          <!--到账确认弹窗 start-->
          <el-dialog
            title="修改到账日期"
            :visible.sync="dialogConfirmLock"
            width="600px"
            :show-close="false">
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="到账日期：">
                    <el-date-picker
                      v-model="confirmTime"
                      type="date"
                      value-format="timestamp"
                      placeholder="选择到账日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="dialogClose(3)">取 消</el-button>
              <el-button type="primary" :disabled="!confirmTime" @click="saveConfirmDialog">确 定</el-button>
            </span>
          </el-dialog>
          <!--到账确认弹窗 start-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';

export default {
  data() {
    return {
      tableData: [],
      uploadExcelFiles: [], // 上传的Excel文件
      btnUploadLoading: false,
      isUploadSuccess: false, // 上传成功
      confirmTime: null,
      dialogConfirmLock: false, // 确认到账日期对话框
      timer: null, // 定时器
      timerIndex: 0, // 定时器指针
      timerRunning: false, // 定时器是否执行
      runLock: true,
      batchTitle: '',
    };
  },
  methods: {
    // 保存确认到账日期
    saveConfirmDialog() {
    },
    // 打开报账文本弹窗
    openAccountDialog(row) {
      this.dialogAccountLock = true;
      this.accountText = row.trade_text;
    },
    // 批量上传
    batchUplaodProcess() {
      this.btnUploadLoading = true;
    },
    batchUplaodSuccess(response) {
      console.log(response);
      if (response.result === -1) {
        this.$message.error(response.msg);
      } else {
        this.isUploadSuccess = true;
        this.tableData = response.data;
      }
      this.btnUploadLoading = false;
    },
    batchUplaodError(err) {
      console.error(err);
      this.$message.error('文件上传失败');
      this.btnUploadLoading = false;
    },
    // 批量执行
    batchConfrim() {
      this.timerRunning ? this.batchConfrimStop() : this.batchConfrimRun();
    },
    batchConfrimRun() {
      this.timerRunning = true;
      // 终止定时任务
      if (this.timerIndex >= this.tableData.length) {
        this.timerRunning = false;
        return;
      }
      this.timer = setInterval(() => {
        // 终止定时任务
        if (!this.timerRunning || this.timerIndex === this.tableData.length) {
          clearInterval(this.timer);
          this.timerRunning = false;
          this.$notify({
            title: '完成',
            message: `已批量完成执行${this.timerIndex}条，具体结果请等待。`,
            type: 'success',
            duration: 3000
          });
          this.runLock = false;
        } else {
          this.batchTitle = `当前执行ID：${this.tableData[this.timerIndex].id}，已执行：${this.timerIndex + 1}/${this.tableData.length}`;
          this.saveConfirmDate(this.timerIndex);
          this.timerIndex++;
        }
      }, 500);
    },
    batchConfrimStop() {
      this.timerRunning = false;
    },
    saveConfirmDate(index) {
      const rowData = this.tableData[index];
      // 自动跳过
      if (rowData.confirm_status === -1) {
        return;
      }
      // console.log(rowData);
      const id = rowData.id;
      const confirmTime = (new Date(rowData.confirm_date)).getTime();

      this.$http
        ._post({
          url: '/finance/trade/financeConfirm',
          data: { id: id, confirmTime: confirmTime / 1000 }
        })
        .then(() => {
          this.tableData[index].confirm_status = 1;
          this.tableData[index].confirm_result = 'OK';
        }).catch((err) => {
          this.tableData[index].confirm_status = -1;
          this.tableData[index].confirm_result = err.data.msg;
        });
    },
    resetConfirm() {
      if (this.timerRunning) {
        this.$message.error('正在执行中，无法重新执行');
        return false;
      }
      this.batchTitle = '';
      this.isUploadSuccess = false;
      this.tableData = [];
      this.timerIndex = 0;
      this.runLock = true;
    }
  },
  components: {
    'jm-crumbs': crumbs
  },
  mounted() {
  },
  computed: {
  }
};
</script>
<style scoped>
  .search-btn{
    clear: both;
    text-align: center;
    padding-bottom: 30px;
  }
  .tableList .el-button{
    padding: 0 13px;
  }
</style>
<style>
  .el-upload-list {
    display: inline-block;
    width: 200px;
    height: 45px;
    position: absolute;
    left: 150px;
    top: 0;
  }
</style>
